<div class="payments">
  <div class="title-buttons">
    <h3>List of payments</h3>
  </div>
  <br />
  <br />
  <div class="table-responsive">
    <table class="table table-striped products-table table-sm" id="payments-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Transaction Ref</th>
          <th>User</th>
          <th>Payment Type</th>
          <th>Method</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Date</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading else table_payments">
          <td colspan="9" style="text-align: center">
            Loading ...
          </td>
        </tr>
        <ng-template #table_payments>
          <tr *ngFor="let payment of payments | paginate : config; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ payment.transactionRef }}</td>
            <td>{{ payment.user.firstName + ' ' + payment.user.lastName }}</td>
            <td>{{ payment.paymentType }}</td>
            <td>{{ payment.paymentMethod }}</td>
            <td>{{ payment.amount }} {{ payment.currency | uppercase }}</td>
            <td>
              <span class="badge" [ngClass]="{
                'bg-success': payment.status === 'SUCCESS',
                'bg-primary': payment.status === 'CONFIRMED',
                'bg-danger': payment.status === 'FAILED',
                'bg-secondary': payment.status === 'REJECTED',
                'bg-brown': payment.status === 'REFUNDED',
                'bg-warning': payment.status === 'PENDING',
                'bg-dark': payment.status === 'CANCELLED'
              }">
                {{ payment.status }}
              </span>
            </td>
            <td>{{ payment.paymentDate | date: 'medium' }}</td>
            <td>
              <button class="btn btn-primary btn-sm" (click)="viewPayment(payment.id)">
                <i class="fa fa-eye"></i> View
              </button>
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
  <div class="toolbar mt-3" *ngIf="!loading">
    <div class="pager">
      <pagination-controls class="pages" maxSize="5" previousLabel="Previous" nextLabel="Next" autoHide="true"
        id="payments" (pageChange)="pageChange($event)"></pagination-controls>
    </div>
  </div>
</div>